import { Component, OnInit } from '@angular/core';
import { QualityControlService } from '../../services/quality-control/quality-control.service';
import { ScreeningState } from '../../../../store/screening/screening.state';
import { Store } from '@ngxs/store';
import { EvidencesModalComponent, RejectModalQcComponent } from '../../../../shared/components';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TvfRequestsService } from '../../../services/tvf-requests.service';
import { TagPrintService } from '../../../services/tag-print/tag-print.service';

interface Divergence {
  questionId: string;
  question: string;
  answerN1: string;
  answerTriage: string;
  repaired: boolean | null;
  selectedItem: string | null;
  repairOptions: any[];
  answerId: string;
}

@Component({
  selector: 'app-checklist-quality-control',
  templateUrl: './checklist-quality-control.component.html',
  styleUrls: ['./checklist-quality-control.component.sass'],
})
export class ChecklistQualityControlComponent implements OnInit {
  divergences: Divergence[] = [];
  idTrade: string;
  classificationType: string;
  isFinished: boolean = false;
  tradeTagInfo: any;

  constructor(
    private _qualityControlService: QualityControlService,
    private _store: Store,
    private _dialog: MatDialog,
    private _toastrService: ToastrService,
    private _router: Router,
    private _requestsService: TvfRequestsService,
    private tagPrintService: TagPrintService
  ) {}

  ngOnInit(): void {
    const { idTrade, classificationType } = this._store.selectSnapshot(ScreeningState);
    this.classificationType = classificationType;
    this.idTrade = idTrade;

    this.getChecklist();
  }

  getChecklist() {
    this._qualityControlService.checklistRepair(this.idTrade).subscribe((response) => {
      if (response) {
        this.divergences = response.map((item: any) => ({
          questionId: item.questionId,
          question: item.question,
          answerN1: item.answerSeller || 'N/A',
          answerTriage: item.answerInternal,
          repaired: null,
          selectedItem: null,
          repairOptions: item.afterRepair?.reasons || [],
          answerId: item.afterRepair?.answerId,
        }));
      }
    });
  }

  get canApprove(): boolean {
    if (this.divergences.length === 0) return false;
    return this.divergences.every((item) => item.repaired === true && item.selectedItem);
  }

  get canReject(): boolean {
    return this.divergences.some((item) => item.repaired === false);
  }

  disapprove() {
    const dialogRef = this._dialog.open(RejectModalQcComponent, {
      width: '800px',
      data: {
        classification: this.classificationType,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const reasonString = result.map((i: string) => i).join(', ');
        this._qualityControlService.disapprove(this.idTrade, reasonString).subscribe({
          next: () => {
            this._toastrService.success('Trade reprovado no controle de qualidade com sucesso.');
            this._router.navigate(['tvf/controle-qualidade']);
          },
          error: (err) => {
            this._toastrService.error('Erro ao reprovar controle de qualidade.');
            console.error(err);
          },
        });
      }
    });
  }

  async approve() {
    const questionsPayload = this.divergences.map((item) => ({
      questionId: item.questionId,
      answerId: item.answerId,
      reasonId: item.selectedItem,
    }));

    this._qualityControlService.approve(this.idTrade, questionsPayload).subscribe({
      next: async () => {
        this.tradeTagInfo = await this._requestsService
          .getTradeTagInformations(this.idTrade)
          .toPromise();

        this.tagPrintService.print({
          ...this.tradeTagInfo,
          warningModelDiverge: this.tradeTagInfo.productDivergence,
        });

        this.isFinished = true;
        this._toastrService.success('Trade aprovado no controle de qualidade com sucesso.');
      },
      error: (err) => {
        this._toastrService.error('Erro ao aprovar trade no controle de qualidade.');
        console.error(err);
      },
    });
  }

  openEvidenceImages() {
    this._dialog.open(EvidencesModalComponent, {
      width: '1000px',
      data: { idTrade: this.idTrade },
      panelClass: 'custom-modal-container',
    });
  }

  async printTag(): Promise<void> {
    const tradeTagInfo = await this._requestsService
      .getTradeTagInformations(this.idTrade)
      .toPromise();

    this.tagPrintService.print({
      ...tradeTagInfo,
      warningModelDiverge: tradeTagInfo.productDivergence,
    });
  }

  backToOverview() {
    this._router.navigate(['tvf/controle-qualidade']);
  }
}
